import React, { useState, useEffect } from "react";
import "./Hero.css";
import { motion } from "framer-motion";

const API_ENDPOINT = process.env.REACT_APP_IMAGE_HANDLER_URL;
const IMAGE_BUCKET = process.env.REACT_APP_IMAGE_BUCKET;

function getImageUrl(key, width) {
  if (!API_ENDPOINT || !IMAGE_BUCKET) {
    if (!getImageUrl._warned) {
      console.warn("Image handler env missing", {
        API_ENDPOINT,
        IMAGE_BUCKET,
      });
      getImageUrl._warned = true;
    }
    return "";
  }

  const imageRequest = {
    bucket: IMAGE_BUCKET,
    key, // e.g. "images/homepage/hexagonmain.png"
    edits: {
      resize: {
        width,
        fit: "inside",
      },
      webp: {
        quality: 80,
      },
    },
  };

  const encoded = btoa(JSON.stringify(imageRequest));
  return `${API_ENDPOINT}/${encoded}`;
}

const Hero = () => {
  const [expanded] = useState(false);
  const [hexUrl, setHexUrl] = useState("");

  useEffect(() => {
    const updateHexagon = () => {
      const w = window.innerWidth || 1280;
      let targetWidth;
      if (w <= 640) targetWidth = 900;
      else if (w <= 1024) targetWidth = 1400;
      else targetWidth = 2000;

      // your S3 key (matches bucket path)
      setHexUrl(getImageUrl("images/homepage/hexagonmain.png", targetWidth));
    };

    updateHexagon();
    window.addEventListener("resize", updateHexagon);
    return () => window.removeEventListener("resize", updateHexagon);
  }, []);

  return (
    <section className="hero-section">
      <div className="hero-content">
        {/* Image section first */}
        <figure className={`hero-image ${expanded && "hidden"}`}>
          <img
            src={hexUrl || undefined}
            alt="Hexagonal diagram centered on AWS logo, surrounded by terms: Analytics, Scalability, Risk Mitigation, Accuracy, Efficiency, Elevate Reputation. Outer hexagon includes: Automated Workflow, Interoperability, HI TRUST Security, Data Connectivity, White Glove Service, and All Done in the USA. Tone emphasizes efficiency and security."
          />
          {/* <img src = "/hexagon.png" alt = "hexagonImage"></img> */}
        </figure>
        {/* Text section second */}
        <article className={`hero-text ${expanded && "hidden"}`}>
          <div className="hero-text-center">
            <h1>Grow and Manage your healthcare business efficiently.</h1>
            <p className="hero-subtitle">
              Automate your credentialing with iCredentialing
            </p>
            <p className="subtitle">
              Secure credentialing automation designed to support healthcare regulatory standards while helping providers accelerate onboarding and billing readiness.
            </p>
            <nav className="hero-buttons">
              <div className="button-container">
                <motion.button
                  className="demo-button"
                  whileHover={{ y: -2 }}
                  whileTap={{ scale: 0.95 }}
                  onClick={() => (window.location.href = "/schedule-demo")}
                >
                  Schedule a Meet
                </motion.button>
                {/* <motion.button
                    className="video-button"
                    whileHover={{ y: -2 }}
                    whileTap={{ scale: 0.95 }}
                    onClick={() => setExpanded(true)}
                  >
                    Watch Video
                  </motion.button> */}
              </div>
            </nav>
          </div>
        </article>
      </div>
    </section>
  );
};

export default Hero;
